import { ToggleSwitch } from "risa-oasis-ui_v2";
import FORM_MATRIX_SWITCH_ITEMS from "../utils/switchItems";

const switchRowClassName =
  "flex flex-row items-center justify-between rounded-md border border-primaryGray-15 p-2";

interface SwitchContainersProps {
  onChangeEmit?: (data: {
    name: string;
    required: boolean;
    value: boolean;
  }) => void;
}

const SwitchContainers = ({ onChangeEmit }: SwitchContainersProps) => {
  return (
    <div className="my-4 flex flex-col gap-3">
      {FORM_MATRIX_SWITCH_ITEMS.map(({ id, label }) => (
        <div key={id} className={switchRowClassName}>
          <div className="text-sm font-medium text-primaryGray-2">{label}</div>
          <ToggleSwitch id={id} onChangeEmit={onChangeEmit ?? (() => {})} />
        </div>
      ))}
    </div>
  );
};

export default SwitchContainers;
